export const FREE_PRODUCTS = ['CP00NOANSCL001F'];
